// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
//   LinearProgress,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';

// export const AdminAssignedFinancialEstablishmentComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedAFE, setSelectedAFE] = useState(null);

//   const [formData, setFormData] = useState({
//     name_of_fe: '',
//     name_of_ca: '',
//     designation: '',
//     ca_address: '',          
//     ph_number: '',
//     email: '',
//     group_of_entities: '',
//     name_of_directors: '',
//     crime_no: '',
//     fir_no: '',
//     company_email: '',
//     company_ph_number: '',
//     address_of_company: '',
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteAFE, setDeleteAFE] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 50 },
//     { id: 'nameOfTheFe', field: 'nameOfTheFe', headerName: 'Name of The FE', width: 200 },
//     { id: 'nameOfCA', field: 'nameOfCA', headerName: 'Name of CA', width: 150 },
//     { id: 'designation', field: 'designation', headerName: 'Designation', width: 150 },
//     { id: 'caAddress', field: 'caAddress', headerName: 'CA Address', width: 250 }, // New column here
//     { id: 'phNo', field: 'phNo', headerName: 'Phone no.', width: 100 },
//     { id: 'emailLink', field: 'emailLink', headerName: 'Email', width: 180 },
//     { id: 'groupOfEntities', field: 'groupOfEntities', headerName: 'Group of Entities', width: 200 },
//     { id: 'nameOfDirectors', field: 'nameOfDirectors', headerName: 'Name of Directors', width: 200 },
//     { id: 'crimeNo', field: 'crimeNo', headerName: 'Crime No.', width: 150 },
//     { id: 'firNo', field: 'firNo', headerName: 'FIR No.', width: 150 },
//     { id: 'companyEmail', field: 'companyEmail', headerName: 'Company Email', width: 180 },
//     { id: 'companyPhNumber', field: 'companyPhNumber', headerName: 'Company Phone', width: 150 },
//     { id: 'addressOfCompany', field: 'addressOfCompany', headerName: 'Address of Company', width: 250 },
//     {
//       id: 'viewDetails',
//       field: 'viewDetails',
//       headerName: 'View Details',
//       width: 120,
//       renderCell: (params) => params.value ? (
//         <a href={params.value} target="_blank" rel="noopener noreferrer">View Details</a>
//       ) : 'No File',
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchAFE();
//   }, []);

//   const fetchAFE = () => {
//     setLoading(true);
//     axios.get(`${API_BASE_URL}/home-notification/assignedfe/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           nameOfTheFe: item.name_of_fe,
//           nameOfCA: item.name_of_ca,
//           designation: item.designation,
//           caAddress: item.ca_address || '',  // New field mapped here
//           phNo: item.ph_number,
//           emailLink: item.email,
//           groupOfEntities: item.group_of_entities || '',
//           nameOfDirectors: item.name_of_directors || '',
//           crimeNo: item.crime_no || '',
//           firNo: item.fir_no || '',
//           companyEmail: item.company_email || '',
//           companyPhNumber: item.company_ph_number || '',
//           addressOfCompany: item.address_of_company || '',
//           viewDetails: item.link || '',
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch assigned financial establishment details:', error);
//         setSnackbarMessage('Failed to load assigned financial establishment details.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddAFE = () => {
//     setIsEditMode(false);
//     setFormData({
//       name_of_fe: '',
//       name_of_ca: '',
//       designation: '',
//       ca_address: '',    // New field reset here
//       ph_number: '',
//       email: '',
//       group_of_entities: '',
//       name_of_directors: '',
//       crime_no: '',
//       fir_no: '',
//       company_email: '',
//       company_ph_number: '',
//       address_of_company: '',
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (afe) => {
//     setIsEditMode(true);
//     setSelectedAFE(afe);
//     setFormData({
//       name_of_fe: afe.nameOfTheFe,
//       name_of_ca: afe.nameOfCA,
//       designation: afe.designation,
//       ca_address: afe.caAddress || '',  // New field loaded here
//       ph_number: afe.phNo,
//       email: afe.emailLink,
//       group_of_entities: afe.groupOfEntities,
//       name_of_directors: afe.nameOfDirectors,
//       crime_no: afe.crimeNo,
//       fir_no: afe.firNo,
//       company_email: afe.companyEmail,
//       company_ph_number: afe.companyPhNumber,
//       address_of_company: afe.addressOfCompany,
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (afe) => {
//     setDeleteAFE(afe);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api.delete(`${API_BASE_URL}/home-notification/assignedfe/${deleteAFE.id}/`)
//       .then(() => {
//         setSnackbarMessage('Assigned Financial Establishment deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchAFE();
//       })
//       .catch((error) => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete assigned financial establishment.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteAFE(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.name_of_fe?.trim()) errors.name_of_fe = 'Name of FE is required';
//     if (!formData.name_of_ca?.trim()) errors.name_of_ca = 'Name of CA is required';
//     if (!formData.designation?.trim()) errors.designation = 'Designation is required';
//     if (!formData.ca_address?.trim()) errors.ca_address = 'CA Address is required';  // New validation
//     if (!formData.ph_number?.trim()) errors.ph_number = 'Phone number is required';
//     if (!formData.email?.trim()) errors.email = 'Email is required';
//     if (!selectedFile && !isEditMode) errors.file = 'File is required';
//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors(prev => ({ ...prev, file: 'File size must be less than 2MB' }));
//       setSelectedFile(null);
//     } else {
//       setFormErrors(prev => ({ ...prev, file: null }));
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = async () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append('name_of_fe', formData.name_of_fe);
//     form.append('name_of_ca', formData.name_of_ca);
//     form.append('designation', formData.designation);
//     form.append('ca_address', formData.ca_address);  // New field appended
//     form.append('ph_number', formData.ph_number);
//     form.append('email', formData.email);
//     form.append('group_of_entities', formData.group_of_entities);
//     form.append('name_of_directors', formData.name_of_directors);
//     form.append('crime_no', formData.crime_no);
//     form.append('fir_no', formData.fir_no);
//     form.append('company_email', formData.company_email);
//     form.append('company_ph_number', formData.company_ph_number);
//     form.append('address_of_company', formData.address_of_company);
//     if (selectedFile) form.append('link', selectedFile);

//     try {
//       setUploading(true);
//       setUploadProgress(0);

//       if (isEditMode) {
//         await api.patch(`${API_BASE_URL}/home-notification/assignedfe/${selectedAFE.id}/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//         });
//         setSnackbarMessage('Assigned Financial Establishment updated successfully.');
//       } else {
//         await api.post(`${API_BASE_URL}/home-notification/assignedfe/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//         });
//         setSnackbarMessage('Assigned Financial Establishment added successfully.');
//       }

//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       fetchAFE();
//       setOpenFormDialog(false);
//     } catch (error) {
//       console.error('Submit failed:', error);
//       setSnackbarMessage('Failed to submit assigned financial establishment.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setUploading(false);
//       setUploadProgress(0);
//     }
//   };

//   if (loading) return <LoadingSpinner size={30} />;

//   return (
//     <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Assigned Financial Establishment
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddAFE} disabled={uploading}>
//           Add Entry
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//       />

//       <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit Assigned Financial Establishment' : 'Add Assigned Financial Establishment'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Name of The FE"
//             fullWidth
//             value={formData.name_of_fe}
//             error={!!formErrors.name_of_fe}
//             helperText={formErrors.name_of_fe}
//             onChange={(e) => setFormData({ ...formData, name_of_fe: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Name of CA"
//             fullWidth
//             value={formData.name_of_ca}
//             error={!!formErrors.name_of_ca}
//             helperText={formErrors.name_of_ca}
//             onChange={(e) => setFormData({ ...formData, name_of_ca: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Designation"
//             fullWidth
//             value={formData.designation}
//             error={!!formErrors.designation}
//             helperText={formErrors.designation}
//             onChange={(e) => setFormData({ ...formData, designation: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="CA Address"     // New field input
//             fullWidth
//             multiline
//             rows={2}
//             value={formData.ca_address}
//             error={!!formErrors.ca_address}
//             helperText={formErrors.ca_address}
//             onChange={(e) => setFormData({ ...formData, ca_address: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Phone no."
//             fullWidth
//             value={formData.ph_number}
//             error={!!formErrors.ph_number}
//             helperText={formErrors.ph_number}
//             onChange={(e) => setFormData({ ...formData, ph_number: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Email"
//             fullWidth
//             value={formData.email}
//             error={!!formErrors.email}
//             helperText={formErrors.email}
//             onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Group of Entities"
//             fullWidth
//             multiline
//             rows={2}
//             value={formData.group_of_entities}
//             onChange={(e) => setFormData({ ...formData, group_of_entities: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Name of Directors"
//             fullWidth
//             multiline
//             rows={2}
//             value={formData.name_of_directors}
//             onChange={(e) => setFormData({ ...formData, name_of_directors: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Crime No."
//             fullWidth
//             value={formData.crime_no}
//             onChange={(e) => setFormData({ ...formData, crime_no: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="FIR No."
//             fullWidth
//             value={formData.fir_no}
//             onChange={(e) => setFormData({ ...formData, fir_no: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Company Email"
//             fullWidth
//             value={formData.company_email}
//             onChange={(e) => setFormData({ ...formData, company_email: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Company Phone"
//             fullWidth
//             value={formData.company_ph_number}
//             onChange={(e) => setFormData({ ...formData, company_ph_number: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Address of Company"
//             fullWidth
//             multiline
//             rows={2}
//             value={formData.address_of_company}
//             onChange={(e) => setFormData({ ...formData, address_of_company: e.target.value })}
//             disabled={uploading}
//           />
//           <Box mt={2}>
//             <input
//               accept="*"
//               style={{ display: 'block', marginTop: '8px' }}
//               id="file-upload"
//               type="file"
//               onChange={handleFileChange}
//               disabled={uploading}
//             />
//             {formErrors.file && (
//               <Typography variant="body2" color="error">{formErrors.file}</Typography>
//             )}
//             {isEditMode && !selectedFile && selectedAFE?.viewDetails && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{' '}
//                 <a href={`${API_BASE_URL}${selectedAFE.viewDetails}`} target="_blank" rel="noopener noreferrer">
//                   View Details
//                 </a>
//               </Typography>
//             )}
//           </Box>
//           {uploading && (
//             <Box sx={{ mt: 2 }}>
//               <LinearProgress variant="determinate" value={uploadProgress} />
//               <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
//                 Uploading... {uploadProgress}%
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
//             {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this assigned financial establishment?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  LinearProgress, Select, MenuItem, FormControl, InputLabel,
  RadioGroup, Radio, FormControlLabel
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import api from '../../api/axiosInterceptor';
import axios from 'axios';

export const AdminAssignedFinancialEstablishmentComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedAFE, setSelectedAFE] = useState(null);

  const [formData, setFormData] = useState({
    name_of_fe: '',
    name_of_ca: '',
    designation: '',
    ca_address: '',
    ph_number: '',
    email: '',
    group_of_entities: '',
    name_of_directors: '',
    crime_no: '',
    fir_no: '',
    company_email: '',
    company_ph_number: '',
    address_of_company: '',
    language: '', // New language field
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [textLink, setTextLink] = useState('');
  const [linkType, setLinkType] = useState('file'); // 'file' or 'text'
  
  const [formErrors, setFormErrors] = useState({});

  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteAFE, setDeleteAFE] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 50 },
    { id: 'nameOfTheFe', field: 'nameOfTheFe', headerName: 'Name of The FE', width: 200 },
    { id: 'nameOfCA', field: 'nameOfCA', headerName: 'Name of CA', width: 150 },
    { id: 'designation', field: 'designation', headerName: 'Designation', width: 150 },
    { id: 'caAddress', field: 'caAddress', headerName: 'CA Address', width: 250 },
    { id: 'phNo', field: 'phNo', headerName: 'Phone no.', width: 100 },
    { id: 'emailLink', field: 'emailLink', headerName: 'Email', width: 180 },
    { id: 'language', field: 'language', headerName: 'Language', width: 120 }, // New language column
    { id: 'groupOfEntities', field: 'groupOfEntities', headerName: 'Group of Entities', width: 200 },
    { id: 'nameOfDirectors', field: 'nameOfDirectors', headerName: 'Name of Directors', width: 200 },
    { id: 'crimeNo', field: 'crimeNo', headerName: 'Crime No.', width: 150 },
    { id: 'firNo', field: 'firNo', headerName: 'FIR No.', width: 150 },
    { id: 'companyEmail', field: 'companyEmail', headerName: 'Company Email', width: 180 },
    { id: 'companyPhNumber', field: 'companyPhNumber', headerName: 'Company Phone', width: 150 },
    { id: 'addressOfCompany', field: 'addressOfCompany', headerName: 'Address of Company', width: 250 },
    {
      id: 'viewDetails',
      field: 'viewDetails',
      headerName: 'View Details',
      width: 120,
      renderCell: (params) => params.value ? (
        <a href={params.value} target="_blank" rel="noopener noreferrer">View Details</a>
      ) : 'No File',
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchAFE();
  }, []);

  const fetchAFE = () => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/home-notification/assignedfe/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          nameOfTheFe: item.name_of_fe,
          nameOfCA: item.name_of_ca,
          designation: item.designation,
          caAddress: item.ca_address || '',
          phNo: item.ph_number,
          emailLink: item.email,
          language: item.language,
          groupOfEntities: item.group_of_entities || '',
          nameOfDirectors: item.name_of_directors || '',
          crimeNo: item.crime_no || '',
          firNo: item.fir_no || '',
          companyEmail: item.company_email || '',
          companyPhNumber: item.company_ph_number || '',
          addressOfCompany: item.address_of_company || '',
          viewDetails: item.link || '',
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch assigned financial establishment details:', error);
        setSnackbarMessage('Failed to load assigned financial establishment details.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddAFE = () => {
    setIsEditMode(false);
    setFormData({
      name_of_fe: '',
      name_of_ca: '',
      designation: '',
      ca_address: '',
      ph_number: '',
      email: '',
      group_of_entities: '',
      name_of_directors: '',
      crime_no: '',
      fir_no: '',
      company_email: '',
      company_ph_number: '',
      address_of_company: '',
      language: '',  // Default language
    });
    setSelectedFile(null);
    setTextLink('');
    setLinkType('file');
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleEdit = (afe) => {
    setIsEditMode(true);
    setSelectedAFE(afe);
    setFormData({
      name_of_fe: afe.nameOfTheFe,
      name_of_ca: afe.nameOfCA,
      designation: afe.designation,
      ca_address: afe.caAddress || '',
      ph_number: afe.phNo,
      email: afe.emailLink,
      group_of_entities: afe.groupOfEntities,
      name_of_directors: afe.nameOfDirectors,
      crime_no: afe.crimeNo,
      fir_no: afe.firNo,
      company_email: afe.companyEmail,
      company_ph_number: afe.companyPhNumber,
      address_of_company: afe.addressOfCompany,
      language: afe.language
    });
    setSelectedFile(null);
    setTextLink(afe.viewDetails || '');
    setLinkType(afe.viewDetails ? 'text' : 'file');
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (afe) => {
    setDeleteAFE(afe);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api.delete(`/home-notification/assignedfe/${deleteAFE.id}/`)
      .then(() => {
        setSnackbarMessage('Assigned Financial Establishment deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchAFE();
      })
      .catch((error) => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete assigned financial establishment.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteAFE(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name_of_fe?.trim()) errors.name_of_fe = 'Name of FE is required';
    if (!formData.name_of_ca?.trim()) errors.name_of_ca = 'Name of CA is required';
    if (!formData.designation?.trim()) errors.designation = 'Designation is required';
    if (!formData.ca_address?.trim()) errors.ca_address = 'CA Address is required';
    if (!formData.ph_number?.trim()) errors.ph_number = 'Phone number is required';
    if (!formData.email?.trim()) errors.email = 'Email is required';
    if (!formData.language) errors.language = 'Language is required';
    // File or text link is optional, so no validation here
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setFormErrors(prev => ({ ...prev, file: 'File size must be less than 2MB' }));
      setSelectedFile(null);
    } else {
      setFormErrors(prev => { const newErrors = { ...prev }; delete newErrors.file; return newErrors; });
      setSelectedFile(file);
    }
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const form = new FormData();
    form.append('name_of_fe', formData.name_of_fe);
    form.append('name_of_ca', formData.name_of_ca);
    form.append('designation', formData.designation);
    form.append('ca_address', formData.ca_address);
    form.append('ph_number', formData.ph_number);
    form.append('email', formData.email);
    form.append('language', formData.language);
    form.append('group_of_entities', formData.group_of_entities);
    form.append('name_of_directors', formData.name_of_directors);
    form.append('crime_no', formData.crime_no);
    form.append('fir_no', formData.fir_no);
    form.append('company_email', formData.company_email);
    form.append('company_ph_number', formData.company_ph_number);
    form.append('address_of_company', formData.address_of_company);

    if (linkType === 'file' && selectedFile) {
      form.append('link', selectedFile);
    } else if (linkType === 'text' && textLink?.trim()) {
      form.append('link', textLink);
    }

    try {
      setUploading(true);
      setUploadProgress(0);

      if (isEditMode) {
        await api.patch(`/home-notification/assignedfe/${selectedAFE.id}/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          params: { lang: formData.language }, 
          onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage('Assigned Financial Establishment updated successfully.');
      } else {
        await api.post(`/home-notification/assignedfe/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          params: { lang: formData.language }, 
          onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage('Assigned Financial Establishment added successfully.');
      }

      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchAFE();
      setOpenFormDialog(false);
    } catch (error) {
      console.error('Submit failed:', error);
      setSnackbarMessage('Failed to submit assigned financial establishment.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (loading) return <LoadingSpinner size={30} />;

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Assigned Financial Establishment
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddAFE} disabled={uploading}>
          Add Entry
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
      />

      <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>{isEditMode ? 'Edit Assigned Financial Establishment' : 'Add Assigned Financial Establishment'}</DialogTitle>
        <DialogContent>
          {/* Text fields */}
          <TextField
            margin="dense"
            label="Name of The FE"
            fullWidth
            value={formData.name_of_fe}
            error={!!formErrors.name_of_fe}
            helperText={formErrors.name_of_fe}
            onChange={(e) => setFormData({ ...formData, name_of_fe: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Name of CA"
            fullWidth
            value={formData.name_of_ca}
            error={!!formErrors.name_of_ca}
            helperText={formErrors.name_of_ca}
            onChange={(e) => setFormData({ ...formData, name_of_ca: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Designation"
            fullWidth
            value={formData.designation}
            error={!!formErrors.designation}
            helperText={formErrors.designation}
            onChange={(e) => setFormData({ ...formData, designation: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="CA Address"
            fullWidth
            multiline
            rows={2}
            value={formData.ca_address}
            error={!!formErrors.ca_address}
            helperText={formErrors.ca_address}
            onChange={(e) => setFormData({ ...formData, ca_address: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Phone no."
            fullWidth
            value={formData.ph_number}
            error={!!formErrors.ph_number}
            helperText={formErrors.ph_number}
            onChange={(e) => setFormData({ ...formData, ph_number: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Email"
            fullWidth
            value={formData.email}
            error={!!formErrors.email}
            helperText={formErrors.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            disabled={uploading}
          />

          {/* Language Dropdown */}
          <FormControl fullWidth margin="dense" error={!!formErrors.language} disabled={uploading}>
            <InputLabel>Language</InputLabel>
            <Select
              value={formData.language}
              label="Language"
              onChange={(e) => setFormData({ ...formData, language: e.target.value })}
            >
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="kn">Kannada</MenuItem>
            </Select>
            {formErrors.language && (
              <Typography variant="body2" color="error" sx={{ mt: 0.5 }}>
                {formErrors.language}
              </Typography>
            )}
          </FormControl>

          {/* Other text fields */}
          <TextField
            margin="dense"
            label="Group of Entities"
            fullWidth
            multiline
            rows={2}
            value={formData.group_of_entities}
            onChange={(e) => setFormData({ ...formData, group_of_entities: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Name of Directors"
            fullWidth
            multiline
            rows={2}
            value={formData.name_of_directors}
            onChange={(e) => setFormData({ ...formData, name_of_directors: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Crime No."
            fullWidth
            value={formData.crime_no}
            onChange={(e) => setFormData({ ...formData, crime_no: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="FIR No."
            fullWidth
            value={formData.fir_no}
            onChange={(e) => setFormData({ ...formData, fir_no: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Company Email"
            fullWidth
            value={formData.company_email}
            onChange={(e) => setFormData({ ...formData, company_email: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Company Phone"
            fullWidth
            value={formData.company_ph_number}
            onChange={(e) => setFormData({ ...formData, company_ph_number: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Address of Company"
            fullWidth
            multiline
            rows={2}
            value={formData.address_of_company}
            onChange={(e) => setFormData({ ...formData, address_of_company: e.target.value })}
            disabled={uploading}
          />

          {/* Link Section - File OR Text Link with Radio Buttons */}
          <Box mt={2}>
            <Typography variant="subtitle2" gutterBottom sx={{ mb: 1 }}>
              Link (Optional)
            </Typography>

            {/* Radio Buttons */}
            <Box sx={{ display: 'flex', gap: 2, mb: 1, alignItems: 'center' }}>
              <FormControl component="fieldset" disabled={uploading}>
                <RadioGroup
                  row
                  value={linkType}
                  onChange={(e) => {
                    setLinkType(e.target.value);
                    if (e.target.value === 'text') setSelectedFile(null);
                    else setTextLink('');
                  }}
                >
                  <FormControlLabel value="file" control={<Radio />} label="Upload File" />
                  <FormControlLabel value="text" control={<Radio />} label="Text Link" />
                </RadioGroup>
              </FormControl>
            </Box>

            {/* File Upload - visible when 'file' selected */}
            {linkType === 'file' && (
              <>
                <input
                  accept="*"
                  style={{ display: 'block', marginBottom: '8px' }}
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  disabled={uploading}
                />
                {formErrors.file && (
                  <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                    {formErrors.file}
                  </Typography>
                )}
              </>
            )}

            {/* Text Link Input - visible when 'text' selected */}
            {linkType === 'text' && (
              <TextField
                margin="dense"
                label="Enter URL"
                fullWidth
                value={textLink}
                onChange={(e) => setTextLink(e.target.value)}
                placeholder="https://example.com/file.pdf"
                disabled={uploading}
                error={formErrors.textLink}
                helperText={formErrors.textLink}
              />
            )}

            {/* Show current file/link in edit mode if no new input */}
            {isEditMode && !selectedFile && !textLink && selectedAFE?.viewDetails && (
              <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                Current Link:{' '}
                <a href={selectedAFE.viewDetails} target="_blank" rel="noopener noreferrer">
                  View Details
                </a>
              </Typography>
            )}
          </Box>

          {uploading && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                Uploading... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
            {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this assigned financial establishment?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
